import { useField } from "formik"
import { CreateBillDialog } from "../../../../../../modules/company/admin/accounting/bill-receivers/components/CreateBillDialog"
import { billReceiverToApi } from "../../../../../../modules/company/admin/accounting/bill-receivers/helpers/billReceiverToApi"
import { createBillReceivers } from "../../../../../../modules/company/admin/accounting/bill-receivers/billReceiversApi"
import { BillReceiversItem } from "../../../../../../modules/company/admin/accounting/bill-receivers/billReceiversTypes"
import { useAppLocalization } from "../../../../../../modules/localization/components/AppLocalizationProvider"
import { useApiMutation } from "../../../../../../core/api/useApiMutation"
import { DynamicConfigKey } from "../../form/formTypes"

type CreateBillReceiverProps = Readonly<{
    companyId: number
    handleCloseDialog: () => void
}>

export const CreateBillReceiver = ({ companyId, handleCloseDialog }: CreateBillReceiverProps) => {
    const { l10n } = useAppLocalization()
    const [_field, _meta, helpers] = useField(DynamicConfigKey.BUYER_PARTIES)

    const { mutate } = useApiMutation(createBillReceivers, {
        async onSuccess(_, data) {
            helpers.setValue(data.billReceiver)
        },
    })

    const onSimpleReceiverSelect = (billReceiver: BillReceiversItem) => {
        helpers.setValue(billReceiver)
    }

    return (
        <CreateBillDialog
            companyId={companyId}
            onSelectBillReceiver={(formValues) => {
                const endpointType = formValues.companySendInvoice
                const endpointValue = formValues.search
                const billType = formValues.type

                const apiRequestBody = billReceiverToApi(formValues, billType, endpointValue, endpointType)

                mutate({ billReceiver: apiRequestBody?.billReceiver })
            }}
            onSimpleSelect={onSimpleReceiverSelect}
            open
            onClose={handleCloseDialog}
            title={l10n.getString("bill-receivers-create-dialog-title")}
        />
    )
}
